/* Product page deescription expander 

	jQuery(".product-page-info__description").addClass("no-show");
    jQuery('a.description-expander-text').click(function () {
		event.preventDefault();
		jQuery(".product-page-info__description").toggleClass("no-show");  
    });

*/
// smooth scrolling to anchor
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

// all external links in new tabs
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
    }
}

// Select all focusable elements and enter
const focusableElements = document.querySelectorAll(
    'a[href], button, input, select, textarea, [tabindex="0"], [role="button"]'
);

focusableElements.forEach((element) => {
    element.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            element.click();
        }
        if (e.key === ' ' && element.getAttribute('role') === 'button') {
            e.preventDefault();
            element.click();
        }
    });
});

// check subscription all
setTimeout(function(){
if (typeof sellingPlansGroup !== 'undefined') {
    [].forEach.call(document.querySelectorAll('.product-page-info__price'), function (el) {
        el.style.display = 'none';
    });
}
}, 1500);
//get footbar height
setTimeout(function(){
    if (window.screen.width < 1024) {
    let height = document.querySelector('.fixed-bottom-position').offsetHeight;
    let footer = document.querySelector('#shopify-section-footer');
    footer.style.paddingBottom = `${height - 30}px`; 
    }
}, 1500);

//add back to login functionality 
setTimeout(function(){
    const backToLogin = document.querySelector('.popup-account__return-to-login');
    if (backToLogin) {
        const loginSection = document.querySelector('.popup-account__login');
        const accountSection = document.querySelector('.popup-account__sign-up');
        backToLogin.addEventListener('click', function(){
            loginSection.classList.remove('d-none-important');
            accountSection.classList.add('d-none-important');
        })
    }
}, 1500);

//product tables in extra div for horizontal scroll
var tbls = document.querySelectorAll('.msproducttable');
tbls.forEach(tbl => {
    if (tbl) {
        var parent = tbl.parentNode;
        var wrapper = document.createElement('div');
        wrapper.style.overflowX = "auto";
        parent.insertBefore(wrapper, tbl);
        wrapper.appendChild(tbl);
    }
});


(document.onreadystatechange = () => {
    if ("complete" === document.readyState) {
        null != document.querySelector(".new-review-form") &&
        (console.log(document.readyState), (document.querySelector('input[name="review[title]"]').value = "Title Placeholder"), (document.querySelector('textarea[name="review[body]"]').value = "Body Placeholder"));
        let first_column = document.getElementById("first-shipping-rates-column");

        if (first_column !== null && first_column.innerHTML.length === 0) {
            first_column.style.display = "none";
        }

        $(".description-expander-text").click(function() {
            $('html,body').animate({
                    scrollTop: $("#tabs-anchor").offset().top},
                'slow');
        });
        document.addEventListener("click", toggleMenu);
        function toggleMenu(event) {
            let country_select = document.getElementById("country-select-btn");
            let country_link_select = document.getElementById("country-dropup-select-btn");
            let language_select = document.getElementById("language-select-btn");
            let icon = $(this).find(".disclosure > .select > span > .icon-theme-005");
            if (event.target.closest(".disclosure")) {
                country_select.classList.toggle("active"),
                    $(this).attr("tabindex", 1).focus(),
                    $(this).toggleClass("active"),
                    $(this).find(".disclosure__list").slideToggle(300),
                    icon.hasClass("down")
                        ? ($(this).find(".disclosure > .select > span > .icon-theme-005").attr("viewBox", "-2 4 27 1"), $(this).find(".disclosure > .select > span > .icon-theme-005").removeClass("down"))
                        : ($(this).find(".disclosure > .select > span > .icon-theme-005").attr("viewBox", "-3 17 27 1"), $(this).find(".disclosure > .select > span > .icon-theme-005").toggleClass("down"));
            } else if (event.target.closest(".country.dropup")) {
                country_link_select.classList.toggle("active"),
                    $(this).attr("tabindex", 1).focus(),
                    $(this).toggleClass("active"),
                    $(this).find(".country__list").slideToggle(300)
            } else if (event.target.closest(".language-dropdown")) {
                let icon = $(this).find(".language-dropdown > .select > span > .icon-theme-005");
                language_select.classList.toggle("active"),
                    $(this).attr("tabindex", 1).focus(),
                    $(this).toggleClass("active"),
                    $(this).find(".language__list").slideToggle(300),
                    icon.hasClass("down")
                        ? ($(this).find(".language-dropdown > .select > span > .icon-theme-005").attr("viewBox", "-2 4 27 1"), $(this).find(".language-dropdown > .select > span > .icon-theme-005").removeClass("down"))
                        : ($(this).find(".language-dropdown > .select > span > .icon-theme-005").attr("viewBox", "-3 17 27 1"), $(this).find(".language-dropdown > .select > span > .icon-theme-005").toggleClass("down"));
            }
            else {

                country_select.classList.remove("active");
                country_link_select.classList.remove("active");
                if($(".language-dropdown").hasClass("active")) {
                    language_select.classList.remove("active");
                    $(this).find(".language__list").slideUp(300);
                    $(this).find(".language-dropdown > .select > span > .icon-theme-005").attr("viewBox", "-2 4 27 1");
                    $(this).find(".language-dropdown > .select > span > .icon-theme-005").removeClass("down");
                }
                $(this).find(".country__list").slideUp(300);
                $(this).find(".disclosure__list").slideUp(300);
                $(this).find(".disclosure > .select > span > .icon-theme-005").attr("viewBox", "-2 4 27 1");
                $(this).find(".disclosure > .select > span > .icon-theme-005").removeClass("down");
            }
        }


        document.querySelectorAll("#country_link").forEach(item => {
            item.addEventListener("click", event => {
                    $document.find(".icon-theme-005").attr("viewBox", "-2 4 27 1");
                    $document.find(".icon-theme-005").removeClass("down");
                    event.preventDefault();
                    const form = $("#country_form");
                    document.getElementById("country_value").value = item.querySelector("a").getAttribute("data-value")
                    form.submit();
                });
            });
        document.querySelectorAll("#language_link").forEach(item => {
            item.addEventListener("click", event => {
                $document.find('.icon-theme-005').attr("viewBox", "-2 4 27 1");
                $document.find('.icon-theme-005').removeClass("down");
                event.preventDefault()
                const form = $('#language_form');
                document.getElementById("language_value").value = item.querySelector('a').getAttribute("data-value")
                form.submit();
            });
        });

        /* Checkbox tick via span */
        document.addEventListener("click", toggleCheckbox);
        function toggleCheckbox(event) {
            const closestSpan = event.target.closest("#checkbox-span");
            if (closestSpan) {
                const checkbox = closestSpan.parentNode.querySelector("[name='customer[accepts_marketing]']");
                checkbox.checked = !checkbox.checked;
            }
        }
    }
});